export default {
  routerPaths: [
    {
      // legacy forward
      path: '/fm-building-mgmt',
      redirect: '/digitaltwin-state-overview',
    },
    {
      path: '/fm-access',
      name: 'ISFMAccess',
      view: 'is/fm/access',
      meta: {
        isDrawerIconLink: true,
        i18n: 'Common.drawer.fmAccess',
        internalHelp: true,
        permissions: {
          or: [
            { subject: 'IsFmAccess', action: 'write' },
            { subject: 'IsFmAccess', action: 'manage' },
          ],
        },
      },
    },
    {
      path: '/fm-access-mgmt',
      name: 'ISFMAccess-Mgmt',
      view: 'is/fm/accessMgmt',
      meta: {
        i18n: 'Common.drawer.fmAccessMgmt',
        internalHelp: true,
        permissions: { subject: 'IsFmAccess', action: 'manage' },
      },
    },
    {
      path: '/fm-ticketing-mgmt',
      name: 'ISFMTicketing-Mgmt',
      view: 'is/fm/ticketingMgmt',
      meta: {
        i18n: 'Common.drawer.fmTicketsMgmt',
        internalHelp: true,
        permissions: {
          or: [
            { subject: 'IsFmTicket', action: 'read' },
            { subject: 'IsFmTicket', action: 'manage' },
          ],
        },
      },
    },
    {
      path: '/fm-add-ticket',
      name: 'ISFMTicketing-Add',
      view: 'is/fm/ticketingAdd',
      meta: {
        i18n: 'Common.drawer.fmTicketsAdd',
        internalHelp: true,
        permissions: {
          or: [
            { subject: 'IsFmTicket', action: 'create' },
            { subject: 'IsFmTicket', action: 'manage' },
          ],
        },
      },
    },
    {
      path: '/fm-ticket-success',
      name: 'ISFMTicketing-Success',
      view: 'is/fm/ticketingSuccess',
      meta: {
        i18n: 'Common.TicketAddSuccess',
        internalHelp: true,
        permissions: {
          or: [
            { subject: 'IsFmTicket', action: 'create' },
            { subject: 'IsFmTicket', action: 'manage' },
          ],
        },
      },
    },
  ],
  drawerLinks: [
    {
      icon: 'fal fa-city',
      text: 'Common.drawer.fmFacilityMgmt',
      children: [
        {
          icon: 'fal fa-ballot-check',
          text: 'Common.drawer.fmTicketsGroup',
          children: [
            {
              to: '/fm-add-ticket',
              icon: 'fal fa-file-plus',
              text: 'Common.drawer.fmTicketsAdd',
            },
            {
              to: '/fm-ticketing-mgmt',
              icon: 'fal fa-ballot-check',
              text: 'Common.drawer.fmTicketsMgmt',
            },
          ],
        },
        {
          icon: 'fal fa-user-lock',
          text: 'Common.drawer.fmAccessGroup',
          children: [
            {
              to: '/fm-access',
              icon: 'fal fa-key',
              text: 'Common.drawer.fmAccess',
              conditions: { userHasKeys: true },
            },
            {
              to: '/fm-access-mgmt',
              icon: 'fal fa-user-lock',
              text: 'Common.drawer.fmAccessMgmt',
            },
          ],
        },
        {
          to: '/help',
          icon: 'fal fa-question-circle',
          text: 'Common.drawer.faq',
          permissions: {
            or: [
              { subject: 'IsFmTicket', action: 'create' },
              { subject: 'IsFmTicket', action: 'read' },
              { subject: 'IsFmTicket', action: 'manage' },
              { subject: 'IsFmAccess', action: 'manage' },
              { subject: 'IsFmAccess', action: 'write' },
            ],
          },
        },
      ],
    },
  ],
};
